import { withRouter, useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useRef } from "react";
import PhoneInput from "react-phone-input-2";
import { Api, auth } from "../provider/firebase";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import { somethingWentWrong } from "../provider/functions";
export default withRouter(PayCart);

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%)',
    paddingBottom: 120,
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  backButton: {
    width: 44,
    height: 44,
    borderRadius: 14,
    background: '#fff',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    fontSize: 18,
    color: '#333',
    flexShrink: 0,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: '-0.5px',
    margin: 0,
    lineHeight: 1.2,
  },
  shopName: {
    display: 'block',
    fontSize: 13,
    fontWeight: 400,
    opacity: 0.6,
    marginTop: 2,
  },
  stepsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    padding: '8px 16px 24px',
    overflowX: 'auto',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexShrink: 0,
  },
  stepNumber: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 600,
  },
  stepNumberActive: {
    background: '#000',
    color: '#fff',
  },
  stepNumberInactive: {
    background: 'rgba(0,0,0,0.08)',
    color: 'rgba(0,0,0,0.4)',
  },
  stepName: {
    fontSize: 12,
    fontWeight: 500,
  },
  stepDivider: {
    width: 20,
    height: 2,
    background: 'rgba(0,0,0,0.1)',
    borderRadius: 1,
  },
  formContainer: {
    padding: '0 16px',
  },
  formCard: {
    background: '#fff',
    borderRadius: 20,
    padding: 24,
    marginBottom: 16,
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.04)',
  },
  iconCircle: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 28,
    margin: '0 auto 20px',
    color: '#fff',
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 8,
  },
  cardDescription: {
    fontSize: 14,
    textAlign: 'center',
    opacity: 0.7,
    marginBottom: 24,
    lineHeight: 1.5,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 10,
    display: 'block',
  },
  phoneInputContainer: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: 14,
    marginTop: 8,
    opacity: 0.7,
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
    padding: '14px 16px',
    background: 'rgba(0,0,0,0.02)',
    borderRadius: 14,
    marginBottom: 12,
    cursor: 'pointer',
    border: '1px solid rgba(0,0,0,0.06)',
  },
  checkboxRowChecked: {
    background: 'rgba(76, 175, 80, 0.08)',
    borderColor: 'rgba(76, 175, 80, 0.3)',
  },
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 8,
    border: '2px solid rgba(0,0,0,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: '#fff',
  },
  checkboxChecked: {
    background: '#4CAF50',
    borderColor: '#4CAF50',
  },
  checkboxLabel: {
    fontSize: 14,
    lineHeight: 1.5,
    color: '#333',
  },
  recaptchaContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
    marginBottom: 10,
  },
  alertCard: {
    background: 'rgba(229, 57, 53, 0.08)',
    borderRadius: 14,
    padding: 16,
    marginBottom: 16,
    border: '1px solid rgba(229, 57, 53, 0.2)',
  },
  alertText: {
    fontSize: 14,
    color: '#c62828',
    lineHeight: 1.5,
    marginBottom: 12,
  },
  alertButton: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: 12,
    border: 'none',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 8,
  },
  bottomSheet: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#fff',
    borderRadius: '24px 24px 0 0',
    padding: '20px 20px 28px',
    boxShadow: '0 -4px 30px rgba(0,0,0,0.1)',
    zIndex: 100,
  },
  submitButton: {
    width: '100%',
    padding: '16px 24px',
    borderRadius: 14,
    border: 'none',
    background: '#000',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    letterSpacing: '-0.2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  submitButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
};

function PayCart({ history }) {
  const dispatch = useDispatch();
  let match = useRouteMatch();
  const isWebStore = match.params.table == "webstore" || match.params.table == "online";
  const language = useSelector((state) => state.language.data);
  const [loading, setloading] = useState(false);

  const [telefon, settelefon] = useState(language.telkodu ?? "");
  const [kvkk, setkvkk] = useState(false);
  const [bilgipaylasim, setbilgipaylasim] = useState(false);
  const [capcaError, setcapcaError] = useState(false);
  const [sendManuel, setsendManuel] = useState(false);
  const [capcaSolved, setcapcaSolved] = useState(false);
  const serverReducer = useSelector((state) => state.server.data);
  const tables = useSelector((state) => state.tables.data);
  const cart = useSelector((state) => state.cart.data);

  useEffect(() => {
    const subscribe = auth.onAuthStateChanged(userData => {
      if (userData) {
        if (isWebStore) {
          history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/paywebstore")
        } else if (serverReducer.auth) {
          history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/paytable")
        } else {
          history.replace((match.params.server ? "/" + match.params.server : "") + "/webstore/paywebstore")
        }
      }
    })
    if (window.recaptchaVerifier) {
      try {
        window.recaptchaVerifier.clear();
      } catch (e) {
        console.log('reCAPTCHA clear hatası:', e);
      }
      window.recaptchaVerifier = null;
    }
    window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
      'size': 'normal',
      'callback': () => {
        console.log('reCAPTCHA solved, proceed with phone number sign-in');
        setcapcaSolved(true);
        setcapcaError(false);
      },
      'expired-callback': () => {
        console.log('reCAPTCHA expired by Google');
        setcapcaSolved(false);
        setcapcaError(true);
      },
      'error-callback': (error) => {
        console.error('reCAPTCHA error:', error);
        setcapcaSolved(false);
        setcapcaError(true);
      }
    });
    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });
    return () => {
      subscribe();
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
    };
  }, [])

  function gonder() {
    if (!bilgipaylasim || !kvkk || !capcaSolved) {
      return somethingWentWrong(language.hata, language.bilgileri_doldurun)
    }
    setloading(true);
    signInWithPhoneNumber(auth, "+" + telefon, window.recaptchaVerifier).then((confirmationResult) => {
      setloading(false);
      window.confirmationResult = confirmationResult
      history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/verify")
    }).catch((error) => {
      setloading(false);
      if (error.code == "auth/invalid-phone-number") {
        return somethingWentWrong(
          language.invalid_phone_number,
          language.invalid_phone_number_text
        );
      } else if (error.code == "auth/too-many-requests") {
        return somethingWentWrong(
          language.hata,
          language.to_many_phone_submit
        );
      } else if (error.code == "auth/error-code:-39") {
        return sendManuelCode();
      } else { console.log(error); alert(error.code) }
    })
  }

  function sendManuelCode() {
    return Api.post("/sendSms", { phone: "+" + telefon }).then((response) => {
      if (response?.data?.success && response?.data?.link) {
        setsendManuel(response?.data?.link)
      }
    })
  }

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => history.goBack()}>
          <i className="fa fa-arrow-left" />
        </button>
        <div>
          <h1 style={{...styles.headerTitle, color: serverReducer.textColor}}>
            {language.login_sayfasi_baslik}
          </h1>
          <span style={{...styles.shopName, color: serverReducer.textColor}}>{serverReducer.title}</span>
        </div>
      </div>

      {/* Steps - Modern Progress Bar */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 20px 28px',
        gap: 0,
      }}>
        {/* Step 1 - Menu */}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1}}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(76, 175, 80, 0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <i className="fa fa-check" style={{color: '#4CAF50', fontSize: 14}}></i>
          </div>
          <span style={{fontSize: 11, fontWeight: 500, color: serverReducer.textColor, opacity: 0.6}}>{language.menu}</span>
        </div>
        
        {/* Line 1-2 */}
        <div style={{flex: 0.5, height: 3, background: '#4CAF50', borderRadius: 2, marginBottom: 22}}></div>
        
        {/* Step 2 - Sepet */}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1}}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(76, 175, 80, 0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <i className="fa fa-check" style={{color: '#4CAF50', fontSize: 14}}></i>
          </div>
          <span style={{fontSize: 11, fontWeight: 500, color: serverReducer.textColor, opacity: 0.6}}>{language.sepet}</span>
        </div>
        
        {/* Line 2-3 */}
        <div style={{flex: 0.5, height: 3, background: '#4CAF50', borderRadius: 2, marginBottom: 22}}></div>
        
        {/* Step 3 - Login (Active) */}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1}}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%',
            background: "#e74c3c" || '#000',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
            boxShadow: `0 4px 14px ${"#e74c3c" || '#000'}40`,
          }}>
            <span style={{color: '#fff', fontSize: 14, fontWeight: 700}}>3</span>
          </div>
          <span style={{fontSize: 11, fontWeight: 600, color: serverReducer.textColor}}>{language.giris || "Giriş"}</span>
        </div>
        
        {/* Line 3-4 */}
        <div style={{flex: 0.5, height: 3, background: 'rgba(0,0,0,0.1)', borderRadius: 2, marginBottom: 22}}></div>
        
        {/* Step 4 - Ödeme */}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1}}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(0,0,0,0.06)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <span style={{color: 'rgba(0,0,0,0.3)', fontSize: 13, fontWeight: 600}}>4</span>
          </div>
          <span style={{fontSize: 11, fontWeight: 500, color: serverReducer.textColor, opacity: 0.4}}>{language.odeme}</span>
        </div>
      </div>

      {/* Form */}
      <div style={styles.formContainer}>
        {/* Phone Card */}
        <div style={styles.formCard}>
          <div style={{...styles.iconCircle, background: `linear-gradient(135deg, ${"#e74c3c" || '#000'}, ${"#e74c3c" || '#333'})`}}>
            <i className="fa fa-phone"></i>
          </div>
          <h2 style={{...styles.cardTitle, color: serverReducer.textColor}}>
            {language.telefon_onay_aciklama || "Telefon Numaranızı Doğrulayın"}
          </h2>
          <p style={{...styles.cardDescription, color: serverReducer.textColor}}>
            {language.login_sayfasi_baslikaciklama || "Siparişinizi tamamlamak için telefon numaranızı doğrulamanız gerekmektedir."}
          </p>

          <label style={{...styles.inputLabel, color: serverReducer.textColor}}>
            <i className="fa fa-mobile-alt" style={{marginRight: 8}}></i>
            {language.telefon_input_placeholder || "Telefon Numarası"}
          </label>
          <div style={styles.phoneInputContainer}>
            <PhoneInput 
              placeholder={"+" + language.telkodu} 
              specialLabel="" 
              value={telefon} 
              onChange={settelefon}
              inputStyle={{
                width: '100%',
                padding: '14px 16px 14px 60px',
                borderRadius: 14,
                border: '1px solid rgba(0,0,0,0.1)',
                fontSize: 16,
                background: 'rgba(0,0,0,0.02)',
                height: 52,
              }}
              buttonStyle={{
                borderRadius: '14px 0 0 14px',
                border: '1px solid rgba(0,0,0,0.1)',
                borderRight: 'none',
                background: 'rgba(0,0,0,0.02)',
              }}
              containerStyle={{
                width: '100%',
              }}
            />
          </div>

          {/* SMS Error Alert */}
          {sendManuel && (
            <div style={styles.alertCard}>
              <p style={styles.alertText}>
                <i className="fa fa-exclamation-circle" style={{marginRight: 8}}></i>
                {language.sms_hatasi_manuel || "Telefon numaranıza mesaj gönderirken bir hata oluştu. Onay kodunu tarafınıza gönderebilmemiz için buraya tıklayarak whatsapp mesajı gönderin."}
              </p>
              <button 
                style={{...styles.alertButton, background: '#25D366', color: '#fff'}}
                onClick={() => window.open(sendManuel, "_blank")}
              >
                <i className="fab fa-whatsapp" style={{marginRight: 8}}></i>
                {language.mesaj_gonder || "Mesaj Gönder"}
              </button>
              <button 
                style={{...styles.alertButton, background: '#333', color: '#fff'}}
                onClick={() => history.replace((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/verify", { phone: "+" + telefon, provider: "manuel" })}
              >
                {language.onay_kodum_var || "Onay Kodumu Aldım"}
              </button>
            </div>
          )}
        </div>

        {/* Terms Card */}
        <div style={styles.formCard}>
          <div style={{...styles.sectionTitle, color: serverReducer.textColor}}>
            <i className="fa fa-shield-alt" style={{marginRight: 8}}></i>
            {language.kullanim_kosullari}
          </div>

          <div 
            style={{...styles.checkboxRow, ...(kvkk ? styles.checkboxRowChecked : {})}}
            onClick={() => setkvkk(!kvkk)}
          >
            <div style={{...styles.checkbox, ...(kvkk ? styles.checkboxChecked : {})}}>
              {kvkk && <i className="fa fa-check" style={{color: '#fff', fontSize: 12}}></i>}
            </div>
            <span style={styles.checkboxLabel}>{language.kullanim_kosullari_kabul}</span>
          </div>

          <div 
            style={{...styles.checkboxRow, ...(bilgipaylasim ? styles.checkboxRowChecked : {})}}
            onClick={() => setbilgipaylasim(!bilgipaylasim)}
          >
            <div style={{...styles.checkbox, ...(bilgipaylasim ? styles.checkboxChecked : {})}}>
              {bilgipaylasim && <i className="fa fa-check" style={{color: '#fff', fontSize: 12}}></i>}
            </div>
            <span style={styles.checkboxLabel}>
              {language.kullanim_kosullari_bilgi_paylaşım.replace("${title}", serverReducer.title)}
            </span>
          </div>

          <div style={styles.recaptchaContainer}>
            <div id="recaptcha-container" className="recaptcha-container" />
          </div>
        </div>
      </div>

      {/* Bottom Sheet */}
      <div style={styles.bottomSheet}>
        <button 
          style={{
            ...styles.submitButton,
            background: '#e74c3c' || '#000',
            ...(loading || !capcaSolved ? styles.submitButtonDisabled : {})
          }}
          disabled={loading || !capcaSolved}
          onClick={gonder}
        >
          {loading ? (
            <div className="spinner-border spinner-border-sm text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <>
              <i className="fa fa-paper-plane"></i>
              {language.telefon_onay_gonder}
            </>
          )}
        </button>
      </div>
    </div>
  );
}




